import React from 'react';
import MyButton from '../Button';
import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';

import './styles.scss';

const EmptyPage = ({ extra, ...props }) => {
  const history = useHistory();
  return (
    <div id="page-not-found" {...props}>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      <div className="content">
        {extra || (
          <>
            <p>Whoops! Page not found.</p>
            <MyButton
              className="btn-primary-custom"
              onClick={() => {
                history.push('/');
              }}
            >
              Back to Home
            </MyButton>
          </>
        )}
      </div>
    </div>
  );
};
export default EmptyPage;
